// Single source of truth for credit display formatting. Takes nanocredits
// (nc), the ledger's base unit — truncates toward zero (not floor: a −120.5
// debit displays as −120, not −121) and always uses the true minus sign
// (U+2212), since toLocaleString on a signed number emits an ASCII hyphen.

export const NANOCREDITS_PER_CREDIT = 1_000_000_000;

function wholeCredits(nc: number): string {
  return Math.trunc(Math.abs(nc) / NANOCREDITS_PER_CREDIT).toLocaleString('en-US');
}

/** Bare magnitude: "3,200", "−120". No sign for zero/positive. */
export function formatCredits(nc: number): string {
  return `${nc < 0 ? '−' : ''}${wholeCredits(nc)}`;
}

/** Explicit sign: "+5,000", "−120", "+0". */
export function formatSignedCredits(nc: number): string {
  return `${nc < 0 ? '−' : '+'}${wholeCredits(nc)}`;
}
